import {START_PROXY_ACTION} from '../actions/start-proxy-action';
import {END_PROXY_ACTION} from '../actions/end-proxy-action';
import {ROOT_MODAL_CLOSED} from '../actions/root-modal-closed';

const initialState = {};
export default function proxyActions(state = initialState, action) {
  switch (action.type) {
    case START_PROXY_ACTION: {
      return {...state, [action.payload.__correlationId__]: action.payload};
    }
    case END_PROXY_ACTION: {
      const newState = {...state};
      delete newState[action.payload.__correlationId__];
      return newState;
    }
    case ROOT_MODAL_CLOSED:
      return initialState;
    default:
      return state;
  }
}
